export const OPENBANK_CODE = '0073';
export const BANKIA_CODE = '2038';
